/* ==========================================================================
   LUNÉA — Mystery cadeau vanaf een bedrag (thema 3.23.0)

   Het cadeau is een gewoon product van €0 (status Verborgen). Dit script houdt de
   winkelwagen in lijn met de regel die snippets/lunea-mystery.liquid uitrekent:
   · data-need="1" en nog geen cadeau   → 1 cadeau toevoegen;
   · data-need="1" en meer dan 1        → terug naar 1;
   · data-need="0" en wel een cadeau    → cadeau eruit (drempel niet gehaald, cadeau op,
                                           actie uit of geen €0).
   Na elke wijziging in de wagen (het aantal of het totaal dat de bezoeker ziet, verandert)
   haalt het de sectie opnieuw op via de Section Rendering API (/?sections=lunea-mystery).
   Zo kloppen bedrag, balk en voorraad, en rekent alleen Liquid.

   De cadeauregel in de lade en op /cart krijgt "Gratis" en geen aantal of verwijderknop:
   het cadeau hangt aan het bedrag, niet aan een keuze. Op /cart worden zijn aantalvelden
   ook uitgeschakeld, zodat "Bijwerken" of "Afrekenen" ze niet meestuurt.

   Regelnummers: de lade (theme.js, lunea-cart.js) wijzigt aantallen per regelnummer. Een
   cadeau erbij of eruit verschuift die nummers tot de lade opnieuw getekend is. Zolang is
   de lijst (en de afrekenknop) inert, zodat een klik geen verkeerde regel raakt.

   Tegen lussen: maximaal 6 acties per pagina; een mislukte actie wordt voor dezelfde
   wagen niet herhaald; na een actie pas verder op een verse sectie. Op /cart alleen
   ingrijpen als de pagina daarna herladen wordt: per wagen (data-sig) één keer per minuut
   en hoogstens 3 keer per minuut (sessionStorage; zonder sessionStorage niet). Zonder
   herladen zouden de regelnummers van theme.js op /cart niet meer kloppen.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__luneaMystery) return;
  window.__luneaMystery = true;

  var SECTION = 'lunea-mystery';
  var MAX_ACTIONS = 6;
  var ACTED_KEY = 'lu-mystery-acted';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Zelfde test als lunea-product-cart.js: op /cart is er geen lade. */
  function isCartPage() {
    if (window.theme && typeof window.theme.cartpage === 'boolean') return window.theme.cartpage;
    return /\/cart\/?$/.test(location.pathname);
  }

  function postJSON(path, body) {
    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json().catch(function () { return {}; });
    });
  }

  function elements() {
    return Array.prototype.slice.call(document.querySelectorAll('lunea-mystery'));
  }

  function read(el) {
    return {
      watch: el.getAttribute('data-watch') === '1',
      variant: el.getAttribute('data-variant') || '',
      need: el.getAttribute('data-need') === '1',
      qty: parseInt(el.getAttribute('data-qty'), 10) || 0,
      keys: (el.getAttribute('data-keys') || '').split(',').filter(Boolean),
      sig: el.getAttribute('data-sig') || '',
      free: el.getAttribute('data-free') || 'Gratis',
      value: el.getAttribute('data-value') || ''
    };
  }

  /* Aantal en totaal zoals de bezoeker ze ziet, alleen de cijfers ("3|14355"). */
  function snapshot() {
    var c = document.querySelector('.js-cart-count');
    var t = document.querySelector('.js-cart-total');
    return (c ? c.textContent : '').replace(/\D/g, '') + '|' + (t ? t.textContent : '').replace(/\D/g, '');
  }

  /* /cart: alleen ingrijpen als we daarna herladen. Per wagen (data-sig) hoogstens één keer
     per minuut, en hoogstens 3 keer herladen per minuut. Twee toestanden die elkaar afwisselen
     (bv. een automatische korting op aantal stuks, waar het cadeau meetelt) maken zo geen lus. */
  function cartPageMayAct(sig) {
    try {
      var now = Date.now();
      var log = JSON.parse(window.sessionStorage.getItem(ACTED_KEY) || '[]');
      if (!Array.isArray(log)) log = [];
      log = log.filter(function (e) { return e && now - e.t < 60000; });
      if (log.length >= 3 || log.some(function (e) { return e.s === sig; })) return false;
      log.push({ s: sig, t: now });
      var out = JSON.stringify(log);
      window.sessionStorage.setItem(ACTED_KEY, out);
      return window.sessionStorage.getItem(ACTED_KEY) === out;
    } catch (e) {
      return false;
    }
  }

  var Mystery = {
    state: null,
    inflight: false,  // een actie loopt: niets anders doen tot then/catch
    stale: false,     // na een geslaagde actie: pas weer ingrijpen op een verse sectie
    epoch: 0,         // telt afgeronde acties; sectie-antwoorden van daarvoor tellen niet
    actions: 0,
    failed: {},
    timer: null,
    fetching: false,
    again: false,
    ui: null,         // { targets, wait, expect } zolang lijst en afrekenknop inert zijn

    init: function () {
      var first = elements()[0];
      if (!first) return;
      this.state = read(first);
      if (!this.state.variant) return;

      var self = this;
      this.decorate();

      var list = document.querySelector('.js-mini-cart-content');
      if (list) {
        new MutationObserver(function () {
          self.decorate();
          // Na de actie opnieuw getekend mét het resultaat (cadeau wel of niet in de lijst):
          // dan kloppen de regelnummers weer. Een late hertekening van vóór de actie telt niet.
          var ui = self.ui;
          if (!ui || !ui.wait) return;
          var shown = !!list.querySelector('.js-remove-mini-cart[data-id="' + self.state.variant + '"]');
          if (shown === ui.expect) self.releaseUI();
        }).observe(list, { childList: true, subtree: true });
      }
      var table = document.getElementById('CartProducts');
      if (table) new MutationObserver(function () { self.decorate(); }).observe(table, { childList: true, subtree: true });

      // theme.js tekent teller en totaal bij elke pagina opnieuw, ook als er niets verandert.
      // Alleen een echt ander aantal of bedrag telt, anders kost elke pagina een verzoek.
      this.snap = snapshot();
      var watcher = new MutationObserver(function () {
        var now = snapshot();
        if (now === self.snap) return;
        self.snap = now;
        self.schedule();
      });
      Array.prototype.forEach.call(document.querySelectorAll('.js-cart-count, .js-cart-total'), function (el) {
        watcher.observe(el, { childList: true, characterData: true, subtree: true });
      });
      window.addEventListener('pageshow', function (e) { if (e.persisted) self.schedule(); });

      this.enforce();
    },

    schedule: function () {
      if (!this.state || !this.state.watch) return;
      var self = this;
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(function () { self.refresh(); }, 250);
    },

    refresh: function () {
      var self = this;
      if (this.fetching) { this.again = true; return; }
      this.fetching = true;
      var epoch = this.epoch;
      fetch(root() + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          // Tijdens een actie: die plant zelf een nieuwe ronde. Gevraagd vóór het einde van
          // een actie: de wagen is intussen veranderd, dus opnieuw ophalen.
          if (self.inflight) return;
          if (epoch !== self.epoch) { self.again = true; return; }
          var html = data && data[SECTION];
          if (!html) return;
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('lunea-mystery');
          if (!fresh) return;
          elements().forEach(function (el) { self.patch(el, fresh); });
          self.state = read(fresh);
          self.stale = false;
          self.decorate();
          self.enforce();
        })
        .catch(function () {})
        .then(function () {
          self.fetching = false;
          if (self.again) { self.again = false; self.schedule(); }
        });
    },

    /* Nieuwe balk overnemen. Zelfde opbouw → alleen tekst, breedte en voorraad bijwerken:
       dan schuift de balk vloeiend en leest een schermlezer de nieuwe zin voor (aria-live). */
    patch: function (el, fresh) {
      Array.prototype.slice.call(el.attributes).forEach(function (a) {
        if (!fresh.hasAttribute(a.name)) el.removeAttribute(a.name);
      });
      Array.prototype.slice.call(fresh.attributes).forEach(function (a) {
        el.setAttribute(a.name, a.value);
      });
      var box = el.querySelector('.lu-mystery__box');
      var nbox = fresh.querySelector('.lu-mystery__box');
      if (!box || !nbox) { el.innerHTML = fresh.innerHTML; return; }
      [['.lu-mystery__text > span', false], ['.lu-mystery__fomo', true]].forEach(function (p) {
        var a = box.querySelector(p[0]);
        var b = nbox.querySelector(p[0]);
        if (!a || !b) return;
        if (a.innerHTML !== b.innerHTML) a.innerHTML = b.innerHTML;
        if (p[1]) a.className = b.className;
      });
      var bar = box.querySelector('.lu-mystery__bar');
      var nbar = nbox.querySelector('.lu-mystery__bar');
      if (bar && nbar) bar.setAttribute('aria-valuenow', nbar.getAttribute('aria-valuenow'));
      var fill = box.querySelector('.lu-mystery__fill');
      var nfill = nbox.querySelector('.lu-mystery__fill');
      if (fill && nfill) fill.style.width = nfill.style.width;
    },

    /* De wagen in lijn brengen met data-need. */
    enforce: function () {
      var s = this.state;
      if (!s || !s.variant || this.inflight || this.stale) return;

      var ops = [];
      if (s.need && s.qty === 0) {
        ops.push({ path: 'cart/add.js', body: { items: [{ id: Number(s.variant), quantity: 1 }] } });
      } else if (s.need && s.qty > 1 && s.keys.length) {
        ops.push({ path: 'cart/change.js', body: { id: s.keys[0], quantity: 1 } });
        s.keys.slice(1).forEach(function (k) { ops.push({ path: 'cart/change.js', body: { id: k, quantity: 0 } }); });
      } else if (!s.need && s.qty > 0) {
        s.keys.forEach(function (k) { ops.push({ path: 'cart/change.js', body: { id: k, quantity: 0 } }); });
      }
      if (!ops.length) {
        // /cart zonder werk: de wagen klopt. Het geheugen tegen lussen mag leeg, zodat een
        // latere zelfde wagen (aantal op, af, weer op) opnieuw geholpen wordt. Een wagen die
        // blijft wisselen, komt hier nooit.
        if (isCartPage()) { try { window.sessionStorage.removeItem(ACTED_KEY); } catch (e) {} }
        return;
      }

      var id = s.sig + '#' + (s.need ? '1' : '0');
      if (this.failed[id] || this.actions >= MAX_ACTIONS) return;
      var onCartPage = isCartPage();
      if (onCartPage && (this.actions > 0 || !cartPageMayAct(s.sig))) return;
      this.actions++;
      this.inflight = true;
      this.lockUI(onCartPage);
      this.ui.expect = s.need;

      var self = this;
      ops.reduce(function (p, op) {
        return p.then(function () { return postJSON(op.path, op.body); });
      }, Promise.resolve())
        .then(function () {
          // /cart: herladen; inflight blijft staan, er gebeurt niets meer op deze pagina.
          if (onCartPage) { window.location.reload(); return; }
          self.inflight = false;
          self.stale = true;
          self.epoch++;
          self.after();
        })
        .catch(function () {
          self.inflight = false;
          self.epoch++;
          self.failed[id] = true;
          self.releaseUI();
          if (!onCartPage) self.schedule();
        });
    },

    /* Lijst en afrekenknop inert zolang de regelnummers kunnen verschuiven. Op /cart het
       formulier (Bijwerken, Afrekenen) tot het herladen. Noodrem: na 10 s altijd vrij. */
    lockUI: function (onCartPage) {
      var self = this;
      var targets = (onCartPage
        ? [document.querySelector('form.cart')]
        : [document.querySelector('.js-mini-cart-content'), document.querySelector('.js-cart-btn-checkout')]
      ).filter(Boolean);
      targets.forEach(function (el) {
        el.setAttribute('inert', '');
        el.setAttribute('aria-busy', 'true');
      });
      this.ui = { targets: targets, wait: false, expect: true };
      window.clearTimeout(this.uiTimer);
      this.uiTimer = window.setTimeout(function () { self.releaseUI(); }, 10000);
    },

    releaseUI: function () {
      if (this.ui) {
        this.ui.targets.forEach(function (el) {
          el.removeAttribute('inert');
          el.removeAttribute('aria-busy');
        });
      }
      this.ui = null;
      window.clearTimeout(this.uiTimer);
    },

    after: function () {
      var self = this;
      // Pas een hertekening van de lade met het resultaat maakt de lijst weer vrij (max. 4 s).
      var list = document.querySelector('.js-mini-cart-content');
      if (this.ui) {
        if (list) {
          this.ui.wait = true;
          window.clearTimeout(this.uiTimer);
          this.uiTimer = window.setTimeout(function () { self.releaseUI(); }, 4000);
        } else {
          this.releaseUI();
        }
      }
      // De lade opnieuw opbouwen zonder hem te openen; teller en totaal veranderen → schedule().
      // (theme.miniCart.updateElements() opent de lade, daarom niet die.)
      if (window.LuneaATC && typeof window.LuneaATC.refresh === 'function') {
        var p = window.LuneaATC.refresh();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } else if (window.theme && window.theme.miniCart && window.theme.miniCart.generateCart) {
        window.theme.miniCart.generateCart();
      }
      this.schedule();
    },

    /* Cadeauregel: "Gratis", geen aantal, geen verwijderknop. */
    decorate: function () {
      var s = this.state;
      if (!s || !s.variant) return;
      var vid = String(s.variant);

      // Lade (theme.js generateCart, LuneaATC en lunea-cart-items maken dezelfde opmaak)
      Array.prototype.forEach.call(document.querySelectorAll('.js-mini-cart-content .mini-cart-item'), function (item) {
        if (item.hasAttribute('data-lu-mystery')) return;
        var rm = item.querySelector('.js-remove-mini-cart');
        if (!rm || String(rm.getAttribute('data-id')) !== vid) return;
        item.setAttribute('data-lu-mystery', '');
        item.classList.add('lu-mystery-line');
        var meta = item.querySelector('.mini-cart-meta');
        var price = null;
        if (meta) {
          for (var i = 0; i < meta.children.length; i++) {
            if (meta.children[i].tagName === 'SPAN') { price = meta.children[i]; break; }
          }
        }
        if (!price) return;
        var after = price.nextSibling;
        if (after && after.nodeType === 3) after.nodeValue = ' ';
        price.className = 'lu-mystery-line__free';
        price.textContent = s.free;
        if (s.value) {
          var v = document.createElement('span');
          v.className = 'lu-mystery-line__value';
          v.textContent = s.value;
          price.parentNode.insertBefore(v, price.nextSibling);
        }
      });

      // /cart: rijen die theme.js na een aantalwijziging opnieuw opbouwt. Het aantalveld
      // houdt zijn naam updates[regelsleutel] (ook na de +/−-knoppen van QtySelector).
      Array.prototype.forEach.call(document.querySelectorAll('#CartProducts tr.cart__row'), function (row) {
        if (row.hasAttribute('data-lu-mystery')) return;
        var inputs = Array.prototype.filter.call(row.querySelectorAll('input[name^="updates["]'), function (inp) {
          return inp.name.slice(8).split(':')[0] === vid;
        });
        if (!inputs.length) return;
        row.setAttribute('data-lu-mystery', '');
        row.classList.add('lu-mystery-row');
        inputs.forEach(function (inp) { inp.disabled = true; });
        Array.prototype.forEach.call(row.querySelectorAll('.cart__item-total'), function (el) {
          if (el.tagName === 'SMALL' || el.classList.contains('cart-item__original-price')) { el.hidden = true; return; }
          el.textContent = s.free + (s.value ? ' · ' + s.value : '');
        });
      });
    }
  };

  // Na alle andere scripts (DOMContentLoaded), zodat window.LuneaATC al bestaat.
  var started = false;
  function start() {
    if (started) return;
    started = true;
    Mystery.init();
  }
  if (document.readyState === 'complete') {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
    window.addEventListener('load', start);
  }
})();
